import gql from 'graphql-tag';
export default gql`
  mutation UpdateReviewId($input: UpdateReviewByIdInput!) {
    updateReviewById(input: $input) {
      clientMutationId
    }
  }
`;
